import styled from "styled-components";

const SmallInput = styled.input`
  width: 25.5rem;
  height: 4rem;
  font-size: 1.6rem;
  border: 0.2rem solid #98a8be;
  margin: 0 0 2.6rem 0;
`;

export default SmallInput;
